import { render, staticRenderFns } from "./LinkMail.vue?vue&type=template&id=489ef372&"
import script from "./LinkMail.vue?vue&type=script&lang=js&"
export * from "./LinkMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports